<template>
    <div>
    <admin-layout>
        <template #header>
            <h2 class="text-xl font-semibold leading-tight text-gray-800">
                Dashboard
            </h2>
        </template>
        <div class="py-12" >
            <div class="mx-auto max-w-7xl">
                <div class="flex justify-between w-full text-center">
                    <h1 class="text-4xl font-bold text-white">{{ client.name }}</h1>
                    <span
                        class="block w-20 h-20 pt-4 text-3xl font-bold text-center text-white bg-pink-600 border-2 border-pink-600 border-solid rounded-full bg-opacity-40">{{
                        bigtotal }}<br></span>
                </div>
                <div class="flex justify-between w-full">
                    <div class="w-3/6 my-4">
                        <div class="p-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            {{ client.email }}
                            <span v-if="client.phone" class="px-2">{{ client.phone }}</span>
                            <br>
                        </div>
                        <div class="p-4 mt-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <h3 class="text-lg font-semibold">Informazioni importanti</h3>
                            <ul v-if="client.userdetail">
                                <li v-if="client.userdetail.name_one"
                                    class="py-2 border-b border-gray-200 border-solid">
                                    <p class="w-full px-2 py-1 mt-2 mb-1 font-bold uppercase bg-red-300">finanza</p>
                                    <p class="w-full px-2 py-1 mt-2 mb-1 font-bold bg-blue-100">Frustrazioni dei clienti
                                        /datore
                                        di lavoro</p>
                                    <p>✅<span class="text-sm"> {{ client.userdetail.fin_one }}</span></p>
                                </li>
                                <li v-if="client.userdetail.fin_two" class="py-2 border-b border-gray-200 border-solid">
                                    <p>✅<span class="text-sm"> {{ client.userdetail.fin_two }}</span></p>
                                </li>
                                <li v-if="client.userdetail.person" class="py-2 border-b border-gray-200 border-solid">
                                    <p class="w-full px-2 py-1 mt-2 mb-1 font-bold uppercase bg-red-300">comprensione
                                    </p>
                                    <p class="w-full px-2 py-1 mt-2 mb-1 font-bold bg-blue-100">La persona di cui si
                                        impegna
                                        maggiormente a osservare i lati positivi questa settimana è</p>
                                    <p>✅<span class="text-sm"> {{ client.userdetail.person }}</span></p>
                                </li>
                                <li v-if="client.userdetail.priority_one"
                                    class="py-2 border-b border-gray-200 border-solid">
                                    <p class="w-full px-2 py-1 mt-2 mb-1 font-bold uppercase bg-red-300">organizzazione
                                        / time
                                        management</p>
                                    <p class="w-full px-2 py-1 mt-2 mb-1 font-bold bg-blue-100">Tre priorità della
                                        settimana</p>
                                    <p>✅<span class="text-sm"> {{ client.userdetail.priority_one }}</span></p>
                                </li>
                                <li v-if="client.userdetail.priority_two"
                                    class="py-2 border-b border-gray-200 border-solid">
                                    <p>✅<span class="text-sm"> {{ client.userdetail.priority_two }}</span></p>
                                </li>
                                <li v-if="client.userdetail.priority_three"
                                    class="py-2 border-b border-gray-200 border-solid">
                                    <p>✅<span class="text-sm"> {{ client.userdetail.priority_three }}</span></p>
                                </li>
                                <li v-if="client.userdetail.goal_one"
                                    class="py-2 border-b border-gray-200 border-solid">
                                    <p class="w-full px-2 py-1 mt-2 mb-1 font-bold uppercase bg-red-300">motivazione</p>
                                    <p class="w-full px-2 py-1 mt-2 mb-1 font-bold bg-blue-100">Tre obiettivi che
                                        vorrebbe
                                        realizzare a livello professionale da qui a cinque anni</p>
                                    <p>✅<span class="text-sm"> {{ client.userdetail.goal_one }}</span></p>
                                </li>
                                <li v-if="client.userdetail.goal_two"
                                    class="py-2 border-b border-gray-200 border-solid">
                                    <p>✅<span class="text-sm"> {{ client.userdetail.goal_two }}</span></p>
                                </li>
                                <li v-if="client.userdetail.goal_three"
                                    class="py-2 border-b border-gray-200 border-solid">
                                    <p>✅<span class="text-sm"> {{ client.userdetail.goal_three }}</span></p>
                                </li>

                                <li v-if="client.userdetail.name_one"
                                    class="py-2 border-b border-gray-200 border-solid">
                                    <p class="w-full px-2 py-1 mt-2 mb-1 font-bold uppercase bg-red-300">Scopri per che
                                        lavoro
                                        sei più portato</p>
                                    <p class="w-full px-2 py-1 mt-2 mb-1 font-bold bg-blue-100">Persone di successo che
                                        vorrebbe
                                        frequentare maggiormente</p>
                                    <p>✅<span class="text-sm"> {{ client.userdetail.name_one }}</span></p>
                                </li>
                                <li v-if="client.userdetail.name_two"
                                    class="py-2 border-b border-gray-200 border-solid">
                                    <p>✅<span class="text-sm"> {{ client.userdetail.name_two }}</span></p>
                                </li>

                            </ul>
                        </div>
                        <div class="p-4 my-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <h3 class="pt-2 text-lg font-semibold">Attività</h3>
                            <form @submit.prevent="submitAchievement">
                                <table class="w-full table-auto">
                                    <thead class="bg-blue-100">
                                        <tr>
                                            <th class="px-4 py-2">Azione</th>
                                            <th class="px-4 py-2">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="px-4 py-2 border">App</td>
                                            <td class="px-4 py-2 border"><label
                                                    class="block font-bold text-gray-500 md:w-2/3"><input
                                                        class="mr-2 leading-tight" type="checkbox" :value="form.exam_01"
                                                        :checked="form.exam_01" v-model="form.exam_01"> <span
                                                        class="text-xs text-gray-400">(3 OSM token)</span> </label></td>
                                        </tr>
                                        <tr>
                                            <td class="px-4 py-2 border">Libro</td>
                                            <td class="px-4 py-2 border">
                                                <label class="block font-bold text-gray-500 md:w-2/3">
                                                    <input class="mr-2 leading-tight" type="checkbox"
                                                        :value="form.exam_02" :checked="form.exam_02"
                                                        v-model="form.exam_02"> <span class="text-xs text-gray-400">(5
                                                        OSM token)</span>
                                                </label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="px-4 py-2 border">Evento</td>
                                            <td class="px-4 py-2 border"><label
                                                    class="block font-bold text-gray-500 md:w-2/3"><input
                                                        class="mr-2 leading-tight" type="checkbox" :value="form.exam_04"
                                                        :checked="form.exam_04" v-model="form.exam_04"><span
                                                        class="text-xs text-gray-400"> (5 OSM token)</span> </label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="px-4 py-2 border">Approfondimento</td>
                                            <td class="px-4 py-2 border"><label
                                                    class="block font-bold text-gray-500 md:w-2/3"><input
                                                        class="mr-2 leading-tight" type="checkbox" :value="form.exam_03"
                                                        :checked="form.exam_03" v-model="form.exam_03"> <span
                                                        class="text-xs text-gray-400">(10 OSM token)</span> </label>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <button type="submit"
                                    class="w-full mt-2 font-bold text-center text-white bg-blue-500 rounded-md hover:bg-green-600">aggiorna
                                    progressi</button>
                            </form>
                        </div>
                        <div class="p-4 my-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <h3 class="pt-2 text-lg font-semibold">Assegna altri OSM Token</h3>
                            <p class="py-2 text-xs text-gray-700">In questa sezione puoi assegnare il numero desiderato
                                di OSM
                                Token ad un utente, fornendo una motivazione scritta.</p>
                            <form @submit.prevent="submitChoice">
                                <div class="flex w-full">
                                    <label for="motive">Aggiungi</label>
                                    <input type="number" min="1" max="1000" id="gemnumber" v-model="gemnumber"
                                        class="w-2/12 px-4 py-1 mx-2 mb-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                                        placeholder="1" />
                                    <span>OSM Coins</span>
                                </div>
                                <div class="flex-col w-full">
                                    <label for="motive">Causa</label>
                                    <input type="text" id="gemmotive" v-model="gemmotive"
                                        class="flex-1 w-full px-4 py-1 mb-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                                        placeholder="Descrivi il motivo" />
                                </div>
                                <button type="submit"
                                    class="w-full mt-2 font-bold text-center text-white bg-blue-500 rounded-md hover:bg-green-600">invia</button>
                            </form>
                            <table v-if="arbitraries.length > 0" class="w-full my-2 table-auto">
                                <thead class="bg-blue-100">
                                    <tr>
                                        <th class="px-4 py-2">Coins</th>
                                        <th class="px-4 py-2">Motivo</th>
                                        <th class="px-4 py-2">Autore</th>
                                        <th class="px-4 py-2">Data</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="random in arbitraries" :key="random.id">
                                        <td class="px-4 py-2 border">{{ random.gem_number }}</td>
                                        <td class="px-4 py-2 border">{{ random.gem_motive }}</td>
                                        <td class="px-4 py-2 border">{{ random.thegiver.name }}</td>
                                        <td class="px-4 py-2 border">{{ random.created_at | moment("DD-MM-YYYY") }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="asked.length > 0" class="p-4 my-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <h3 class="pt-2 text-lg font-semibold">Richieste</h3>
                            <p class="py-2 text-xs text-gray-700">In questa sezione puoi visualizzare le richieste
                                arrivate per
                                il completamento di altri obiettivi. Utilizza il box qui sopra per attribuire gli OSM
                                token
                                richiesti.</p>
                            <table class="w-full table-auto">
                                <thead class="bg-blue-100">
                                    <tr>
                                        <th class="px-4 py-2">Richiesta</th>
                                        <th class="px-4 py-2">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="ask in asked" :key="ask.id">
                                        <td class="px-4 py-2 border">{{ ask.question }}
                                            <span
                                                v-if="ask.client_email && ask.question == 'ho portato un nuovo cliente a OSM'"
                                                class="px-1 text-xs text-blue-600">( {{ ask.client_email }} )</span>
                                            <span v-if="ask.event_place != null" class="text-xs">{{ ask.event_place }} |
                                            </span>
                                            <span v-if="ask.event_date != null" class="text-xs">{{ ask.event_date }} |
                                            </span>
                                            <span v-if="ask.event_title != null" class="text-xs">{{ ask.event_title }} |
                                            </span>
                                            <span v-if="ask.event_speaker != null" class="text-xs">{{ ask.event_speaker
                                                }}</span>
                                        </td>
                                        <td class="flex px-4 py-2 text-center border">
                                            <form @submit.prevent="updateAsk(ask.id)" class="w-6/12">
                                                <button type="submit" v-if="ask.status == 'request'"
                                                    class="px-4 py-1 bg-yellow-200 rounded-lg">
                                                    {{ ask.status }}
                                                </button>
                                                <button type="submit" v-if="ask.status == 'done'"
                                                    class="px-4 py-1 text-green-600 bg-green-200 rounded-lg">
                                                    {{ ask.status }}
                                                </button>
                                            </form>
                                            <form v-if="ask.status == 'request'" @submit.prevent="deleteAsk(ask.id)"
                                                class="w-6/12">
                                                <button
                                                    class="flex items-center justify-center w-4 h-4 mx-4 my-2 font-bold text-center text-white bg-red-400 rounded-full">x</button>
                                            </form>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="client.theprizes.length > 0"
                            class="p-4 my-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <h3 class="pt-2 text-lg font-semibold">Premi</h3>
                            <p class="py-2 text-xs text-gray-700">In questa sezione puoi assegnare i premi modificandone
                                lo
                                stato da "pending" a "done". Il cliente riceverà immediatamente una email con il premio.
                                I OSM
                                Coin necessari al premio verranno sottratti dal totale.</p>
                            <table class="w-full table-auto">
                                <thead class="bg-blue-100">
                                    <tr>
                                        <th class="px-4 py-2">Premio</th>
                                        <th class="px-4 py-2">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="prize in client.theprizes" :key="prize.id">
                                        <td v-if="prize.prize_id" class="px-4 py-2 border">{{ prize.prize_id }}</td>
                                        <td v-else class="px-4 py-2 text-pink-600 border">
                                            <span v-if="prize.coin_prize_id == 100">sconto 100 €</span>
                                            <span v-if="prize.coin_prize_id == 150">sconto 200 €</span>
                                            <span v-if="prize.coin_prize_id == 300">sconto 500 €</span>
                                            <span v-if="prize.coin_prize_id == 500">corso leadership</span>
                                        </td>
                                        <td class="flex px-4 py-2 text-center border">
                                            <form @submit.prevent="submitPrize(prize.id)" class="w-6/12">
                                                <button type="submit" :value="prize.id" v-if="prize.status == 'pending'"
                                                    class="px-4 py-1 bg-yellow-200 rounded-lg">
                                                    {{ prize.status }}
                                                </button>
                                                <button v-if="prize.status == 'done'"
                                                    class="px-4 py-1 text-green-600 bg-green-200 rounded-lg">
                                                    {{ prize.status }}
                                                </button>
                                            </form>
                                            <form v-if="prize.status == 'pending'"
                                                @submit.prevent="deletePrize(prize.id)" class="w-6/12">
                                                <button
                                                    class="flex items-center justify-center w-4 h-4 mx-4 my-2 font-bold text-center text-white bg-red-400 rounded-full">x</button>
                                            </form>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="client.theiosm.length > 0"
                            class="p-4 my-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <h3 class="pt-2 text-lg font-semibold">iOsm</h3>
                            <p class="py-2 text-xs text-gray-700">In questa sezione puoi assegnare 1 OSM Token per ogni
                                corso
                                iOSM effettuato. Modificando lo stato da "request" a "done", il cliente riceverà un OSM
                                Coin e
                                una email di notifica.</p>
                            <table class="w-full table-auto">
                                <thead class="bg-blue-100">
                                    <tr>
                                        <th class="px-4 py-2">Iosm</th>
                                        <th class="px-4 py-2">Email</th>
                                        <th class="px-4 py-2">Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="iosm in client.theiosm" :key="iosm.id">
                                        <td class="px-4 py-2 border">corso iOsm</td>
                                        <td class="px-4 py-2 border">{{ iosm.email }}</td>
                                        <td class="flex px-4 py-2 text-center border">
                                            <form @submit.prevent="submitIosm(iosm.id)" class="w-6/12">
                                                <button type="submit" v-if="iosm.status == 'request'"
                                                    class="px-4 py-1 bg-yellow-200 rounded-lg">
                                                    {{ iosm.status }}
                                                </button>
                                                <button v-if="iosm.status == 'done'"
                                                    class="px-4 py-1 text-green-600 bg-green-200 rounded-lg">
                                                    {{ iosm.status }}
                                                </button>
                                            </form>
                                            <form v-if="iosm.status == 'request'" @submit.prevent="deleteIosm(iosm.id)"
                                                class="w-6/12">
                                                <button
                                                    class="flex items-center justify-center w-4 h-4 mx-4 my-2 font-bold text-center text-white bg-red-400 rounded-full">x</button>
                                            </form>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="p-4 my-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <h3 class="pt-2 text-lg font-semibold">Sottrai OSM Token</h3>
                            <p class="py-2 text-xs text-gray-700">In questa sezione puoi eliminare il numero desiderato
                                di OSM
                                Token ad un utente, fornendo una motivazione scritta.</p>
                            <form @submit.prevent="submitDelete">
                                <div class="flex w-full">
                                    <label for="motive">Elimina</label>
                                    <input type="number" min="1" max="1000" id="delnumber" v-model="delnumber"
                                        class="w-2/12 px-4 py-1 mx-2 mb-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                                        placeholder="1" />
                                    <span>OSM Coins</span>
                                </div>
                                <div class="flex-col w-full">
                                    <label for="motive">Causa</label>
                                    <input type="text" id="delmotive" v-model="delmotive"
                                        class="flex-1 w-full px-4 py-1 mb-2 text-base text-gray-700 placeholder-gray-400 bg-white border border-transparent border-gray-300 rounded-lg shadow-sm appearance-none focus:outline-none focus:ring-2 focus:ring-purple-600 focus:border-transparent"
                                        placeholder="Descrivi il motivo" />
                                </div>
                                <button type="submit"
                                    class="w-full mt-2 font-bold text-center text-white bg-blue-500 rounded-md hover:bg-green-600">invia</button>
                            </form>
                            <table v-if="subtractions.length > 0" class="w-full my-2 table-auto">
                                <thead class="bg-blue-100">
                                    <tr>
                                        <th class="px-4 py-2">Coins</th>
                                        <th class="px-4 py-2">Motivo</th>
                                        <th class="px-4 py-2">Autore</th>
                                        <th class="px-4 py-2">Data</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="deleted in subtractions" :key="deleted.id">
                                        <td class="px-4 py-2 border">{{ deleted.gem_number }}</td>
                                        <td class="px-4 py-2 border">{{ deleted.gem_motive }}</td>
                                        <td class="px-4 py-2 border">{{ deleted.theequalizer.name }}</td>
                                        <td class="px-4 py-2 border">{{ deleted.created_at | moment("DD-MM-YYYY") }}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <!-- show completed book -->
                        <div v-if="completedChapterBooks.length !== 0"
                            class="p-4 mt-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <h4 class="font-semibold capitalize text-md">libri completati</h4>
                            <hr class="my-2">
                            <ul v-for="(completedChapterBook, index, key) in completedChapterBooks"
                                :key="completedChapterBook.id">
                                <li>
                                    <span class="mt-2 font-semibold text-gray-700">{{ key + 1 + '. ' + index }}</span>
                                    <ul v-for="(chapter) in completedChapterBook" :key="chapter.id">
                                        <li v-if="chapter.chapter_data !== null" class="text-sm">
                                            {{ '--> ' + chapter.chapter_data.title }}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>

                        <!-- show order lists of product -->
                        <div v-if="purchasedProductList.length > 0"
                            class="p-4 mt-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <h4 class="font-semibold capitalize text-md">Ordered Lists</h4>
                            <hr class="my-2">
                            <div class="inline-block min-w-full overflow-hidden rounded-lg shadow-md">
                                <table class="min-w-full leading-normal">
                                    <thead>
                                        <tr>
                                            <th
                                                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-700 uppercase bg-gray-100 border-b-2 border-gray-200">
                                                Cover Image
                                            </th>
                                            <th
                                                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-700 uppercase bg-gray-100 border-b-2 border-gray-200">
                                                Amount
                                            </th>
                                            <th
                                                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-700 uppercase bg-gray-100 border-b-2 border-gray-200">
                                                Category
                                            </th>
                                            <th
                                                class="px-5 py-3 text-xs font-semibold tracking-wider text-left text-gray-700 uppercase bg-gray-100 border-b-2 border-gray-200">
                                                Author
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="productData in purchasedProductList" :key="productData.id">
                                            <td class="px-5 py-5 text-sm bg-white border-b border-gray-200">
                                                <div class="flex">
                                                    <div class="flex-shrink-0 w-10 h-10">
                                                        <img class="w-full h-full rounded-full"
                                                            :src="productData.cover_image" alt="cover" />
                                                    </div>
                                                    <div class="ml-3">
                                                        <p class="font-semibold text-gray-900 whitespace-no-wrap">
                                                            {{ productData.name }}
                                                        </p>
                                                        <p class="text-gray-600 whitespace-no-wrap"> {{ productData.code
                                                            }}</p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="px-5 py-5 text-sm bg-white border-b border-gray-200">
                                                <p class="text-gray-900 whitespace-no-wrap"><strong>€{{
                        productData.price
                    }}</strong></p>
                                                <p class="text-gray-600 whitespace-no-wrap">EURO</p>
                                            </td>
                                            <td class="px-5 py-5 text-sm bg-white border-b border-gray-200">
                                                <span
                                                    class="relative inline-block px-3 py-1 font-semibold leading-tight text-pink-900">
                                                    <span aria-hidden
                                                        class="absolute inset-0 bg-pink-200 rounded-full opacity-50"></span>
                                                    <span class="relative">{{ productData.product_category.name
                                                        }}</span>
                                                </span>
                                            </td>
                                            <td class="px-5 py-5 text-sm text-right bg-white border-b border-gray-200">
                                                {{ productData.book_data.author }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <!-- second section -->
                    <div class="w-2/5 my-4">
                        <div v-if="client.gems > 0" class="p-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <h3 class="mb-2 text-lg font-bold">OSM Token</h3>
                            <ul class="pb-4">
                                <li class="flex justify-between w-full py-1 my-1 border-b border-gray-200"><span
                                        class="inline-block text-left">Consegna Questionario:</span><span
                                        class="inline-block text-right">{{ gems }}</span></li>
                                <li class="flex justify-between w-full py-1 my-1 border-b border-gray-200"><span
                                        class="inline-block text-left">Programmi completati:</span><span
                                        class="inline-block text-right">{{ results }}</span></li>
                                <li class="flex justify-between w-full py-1 my-1 border-b border-gray-200"><span
                                        class="inline-block text-left">Corsi iOsm:</span><span
                                        class="inline-block text-right">{{ iosmresults }}</span></li>
                                <li class="flex justify-between w-full py-1 my-1 border-b border-gray-200"><span
                                        class="inline-block text-left">Attività OSM:</span><span
                                        class="inline-block text-right">{{ allbonus }}</span></li>
                                <li class="flex justify-between w-full py-1 my-1 border-b border-gray-200"><span
                                        class="inline-block text-left">Assegnazione libera:</span><span
                                        class="inline-block text-right">{{ arbitrary_sum }}</span></li>
                                <li class="flex justify-between w-full py-1 my-1 border-b border-gray-200"><span
                                        class="inline-block text-left">Eliminati:</span><span
                                        class="inline-block text-right">-{{ subtraction_sum }}</span></li>
                                <li v-if="win === 20"
                                    class="flex justify-between w-full py-1 my-1 border-b border-gray-200">
                                    <span class="inline-block text-left">Premi assegnati</span><span
                                        class="inline-block text-right">-20</span>
                                </li>
                                <li class="flex justify-between w-full py-1 my-1 border-b border-gray-200"><span
                                        class="inline-block text-left">Download:</span><span
                                        class="inline-block text-right">-{{
                        download }}</span></li>
                                <li class="flex justify-between w-full py-1 my-1 border-b border-gray-200"><span
                                        class="inline-block text-left">Orders:</span><span
                                        class="inline-block text-right">-{{
                        order }}</span></li>
                                <li class="flex justify-between w-full"><span
                                        class="inline-block font-semibold text-left">Totale OSM Coins:</span><span
                                        class="inline-block font-semibold text-right">{{ bigtotal }}</span></li>
                            </ul>
                        </div>
                        <progress class="my-2 progress" :value="grandTotal" max="100"></progress>
                        <div v-if="client.theworkout.length > 0"
                            class="p-4 mt-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <h3 class="mb-2 text-lg font-bold">Programmi completati</h3>
                            <ul>
                                <li v-for="work in client.theworkout" :key="work.id"
                                    class="py-1 my-1 border-b border-gray-200">
                                    ✅ {{ work.hascurriculum.title }}</li>
                            </ul>
                        </div>
                        <div v-if="contactrequest == true"
                            class="p-4 mt-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <h4 class="text-md">Ha richiesto di partecipare a un evento</h4>
                            <hr class="my-2">
                            <p v-if="contact.entrepreneur == 1"><span class="font-bold">Imprenditore</span></p>
                            <p><span class="font-bold">Telefono:</span> {{ contact.phone }}</p>
                            <p><span class="font-bold">Città:</span> {{ contact.city}}</p>
                            <hr class="my-2">
                            <p>Evento fatto?</p>
                            <form @submit.prevent="updateEvent">
                                <button v-if="contact.status == 'done'" type="submit"
                                    class="inline-block w-auto px-4 text-white bg-green-600 rounded-md">Sì</button>
                                <button v-else type="submit"
                                    class="inline-block w-auto px-4 border border-gray-800 rounded-md hover:bg-blue-700 hover:text-white hover:border-white">Sì</button>
                                <div class="inline-block w-auto px-4 border border-gray-800 rounded-md">No</div>
                            </form>
                        </div>
                        <div v-on:click="showQr = !showQr"
                            class="p-4 mt-6 font-bold text-white bg-pink-600 rounded-md cursor-pointer">carica il QR
                            Code per il
                            cliente</div>
                        <div v-if="showQr == true" class="p-4 mt-4 bg-white shadow-xl sm:rounded-lg">
                            <QrAdmin :user="client.id" />
                        </div>

                        <!--balance-->
                        <div class="px-2 py-2 mt-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <span class="text-lg font-medium">Wallet Balance:</span>
                            <span class="px-2">{{ formatNumber(balance.balance) }}</span>
                            <br>
                        </div>

                        <div class="px-2 py-2 mt-4 overflow-hidden bg-white shadow-xl sm:rounded-lg">
                            <span class="text-lg font-bold">Assign Badges:</span>
                            <form @submit.prevent="assignBadges">
                                <div v-for="badge in badgeList" :key="badge.value" class="mt-2">
                                    <label>
                                        <input type="checkbox" v-model="selectedBadges" :value="badge.value"
                                            :checked="isBadgeAssigned(badge.value)" class="mr-2" />
                                        {{ badge.label }}
                                    </label>
                                </div>
                                <button type="submit" class="px-4 py-2 mt-4 text-white bg-blue-600 rounded-md">Assign
                                    Badges</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </admin-layout>
</div>
</template>

<script>
import AdminLayout from '@/Layouts/AdminLayout'
import QrAdmin from '@/Components/QrAdmin'
import Swal from "sweetalert2";

export default {
    props: ['balance', 'client', 'exams', 'results', 'badges', 'iosmresults', 'allbonus', 'gems', 'win', 'bigtotal', 'contact', 'contactrequest', 'arbitraries', 'arbitrary_sum', 'asked', 'subtractions', 'subtraction_sum', 'completedChapterBooks', 'download', 'order', 'purchasedProductList'],
    components: {
        AdminLayout,
        QrAdmin
    },
    data() {
        return {
            sending: false,
            showQr: false,
            gemnumber: this.gemnumber,
            gemmotive: this.gemmotive,
            delnumber: this.delnumber,
            delmotive: this.delmotive,
            selectedBadges: [],
            badgeList: [
                { label: 'Age Badge', value: 'bdg_age' },
                { label: 'Volunteer Badge', value: 'bdg_volunteer' },
                { label: 'Sponsor Badge', value: 'bdg_sponsor' },
                { label: 'INSS Badge', value: 'bdg_inss' },
                { label: 'Graduate Badge', value: 'bdg_graduate' },
                { label: 'First Badge', value: 'bdg_first' },
                { label: 'Super Badge', value: 'bdg_super' },
                { label: 'Ambassador Badge', value: 'bdg_ambassador' },
                { label: 'Silver Badge', value: 'bdg_silver' },
                { label: 'Gold Badge', value: 'bdg_gold' },
                { label: 'Diamond Badge', value: 'bdg_diamond' },
            ],
            form: {
                user: this.client.id,
                exam_01: this.exams['get_app'].achieve,
                exam_02: this.exams['get_book'].achieve,
                exam_03: this.exams['get_one'].achieve,
                exam_04: this.exams['get_event'].achieve,
            },
            theprize: {
                user: this.client.id,
                prize: 20
            },
            iosmdata: {
                user: this.client.id,
                prize: 1
            },
            eventdata: {
                user: this.client.id,
                status: 'done'
            },
            askdata: {
                user: this.client.id,
                status: 'done'
            },
        };
    },
    mounted() {
        // Pre-select badges based on what is already assigned to the user
        this.preselectBadges();
    },

    methods: {
        preselectBadges() {
            // Loop through the badge columns and check which ones are true
            this.badgeList.forEach(badge => {
                if (this.badges && this.badges[badge.value]) {
                    this.selectedBadges.push(badge.value);
                }
            });
        },
        isBadgeAssigned(badgeValue) {
            return this.badges && this.badges[badgeValue];
        },

        assignBadges() {
            const data = new FormData();
            data.append('user', this.client.id);

            // Add selected badges to the form data
            this.selectedBadges.forEach((badge) => {
                data.append('badges[]', badge);
            });
            this.$inertia.post(this.route('badges.assign'), data, {
                onStart: () => this.sending = true,
                onFinish: () => this.sending = false,
            })
            .then(response => {
                Swal.fire({
                title: 'Success!',
                text: 'Badge assigned successfully.',
                icon: 'success',
                timer: 3000, 
                backdrop: false,
                showConfirmButton: false, 
                willClose: () => {
                location.reload(); 
                }
                });
            })
            .catch(error => {
                Swal.fire({
                title: 'Error!',
                text: 'There was an issue assigning the badge.',
                icon: 'error',
                confirmButtonText: 'OK'
                });

                console.error('Error:', error); // Log error if needed
            });
        },
         submitAchievement() {
            this.$inertia.post(this.route('achievement.update'), this.form)
                .then(response => {
                    Swal.fire({
                    title: 'Success!',
                    text: 'Achievements updated successfully.',
                    icon: 'success',
                    timer: 3000, 
                    backdrop: false,
                    showConfirmButton: false, 
                    willClose: () => {
                    location.reload(); 
                    }
                    });
                })
                .catch(error => {
                console.error('Error:', error);
                Swal.fire({
                    title: 'Error!',
                    text: 'There was an issue updating the achievements.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
                });
            },

        submitPrize(id) {
            this.$inertia.post(('/prize/update/' + id), this.theprize)
        },
        submitIosm(id) {
            this.$inertia.post(('/iosm/update/' + id), this.iosmdata)
        },
        updateEvent() {
            this.$inertia.post(this.route('contact.update'), this.eventdata)
        },
        updateAsk(id) {
            this.$inertia.post(('/asks/update/' + id), this.askdata)
        },
        submitChoice() {
            const data = new FormData();
            data.append('user', this.client.id);
            data.append('gemnumber', this.gemnumber || ''); // Ensure a default value if undefined
            data.append('gemmotive', this.gemmotive);
            this.$inertia.post(this.route('arbitrary.create'), data, {
                onStart: () => this.sending = true,
                onFinish: () => this.sending = false,
            })
            .then(response => {
                Swal.fire({
                title: 'Success!',
                text: 'Gems added successfully.',
                icon: 'success',
                timer: 3000, 
                backdrop: false,
                showConfirmButton: false, 
                willClose: () => {
                location.reload(); 
                }
                });

                console.log('Response:', response); // Log response if needed
            })
            .catch(error => {
                Swal.fire({
                title: 'Error!',
                text: 'There was an issue adding the gems.',
                icon: 'error',
                confirmButtonText: 'OK'
                });

                console.error('Error:', error); // Log error if needed
            });
        },
        submitDelete() {
            const data = new FormData()
            data.append('user', this.client.id);
            data.append('delnumber', this.delnumber || ''); 
            data.append('delmotive', this.delmotive);
            this.$inertia.post(this.route('subtraction.create'), data, {
                onStart: () => this.sending = true,
                onFinish: () => 
                {
                    this.sending = false;
                }
            })
            .then(response => {
                Swal.fire({
                title: 'Success!',
                text: 'Subtraction crated successfully.',
                icon: 'success',
                timer: 3000, 
                backdrop: false,
                showConfirmButton: false, 
                willClose: () => {
                location.reload(); 
                }
                });
            })
            .catch(error => {
                Swal.fire({
                title: 'Error!',
                text: 'There was an issue adding the gems.',
                icon: 'error',
                confirmButtonText: 'OK'
                });
                console.error('Error:', error); // Log error if needed
            });
        },
        deleteAsk(id) {
            this.$inertia.post(('/asks/delete/' + id), this.askdata)
        },
        deleteIosm(id) {
            this.$inertia.post(('/iosmdelete/' + id), this.iosmdata)
        },
        deletePrize(id) {
            this.$inertia.post(('/prizedelete/' + id), this.theprize)
        },
        formatNumber(value) {
            // If value is null or undefined, return "0"
            if (value === null || value === undefined) {
                return "0";
            }

            // Ensure the value is a number
            let numberValue = parseFloat(value);

            // If the parsed value is not a valid number, return "0"
            if (isNaN(numberValue)) {
                return "0";
            }

            // Convert to string and split integer and decimal parts
            let [integerPart, decimalPart] = numberValue.toFixed(2).toString().split(".");

            // Add thousand separators (dots) to the integer part
            let formattedInt = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, "'");

            // Combine the integer part with the decimal part using a comma as the decimal separator
            return decimalPart ? formattedInt + "," + decimalPart : formattedInt;
        }
    },
    computed: {
        grandTotal: function () {
            return parseInt(
                this.gems + this.results + this.iosmresults + this.allbonus - this.win
            );
        },

    }

}
</script>

<style>


</style>